import React, {useContext, useEffect, useRef, useState} from "react";
import {useHistory} from 'react-router-dom';
import * as Yup from "yup";
import {TranslateContext} from "../../context/TranslateContext";
import {aggiungiStrutturaClasseMacrocategoriaApi, getClassiMacrocategorieApi} from "./services/MacrocategorieServices";
import ModificaStrutturaClasseMacrocategoriaView from "./ModificaStrutturaClasseMacrocategoriaView";

export default function ModificaStrutturaClasseMacrocategoriaController() {

    const [optionsClassi, setOptionsClassi] = useState([]);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {translate} = useContext(TranslateContext);

    const history = useHistory();
    const formikRef = useRef();

    async function getClassiMacrocategorie() {
        const response = await getClassiMacrocategorieApi();
        setOptionsClassi(response.data.data);
    }

    useEffect(() => {
        getClassiMacrocategorie();
    }, []);

    const SignupSchema = Yup.object().shape({
        id_classe_macrocategoria: Yup.string().required(translate('Questo campo è obbligatorio')),
        id_classe_macrocategoria_madre: Yup.string().required(translate('Questo campo è obbligatorio')),
    });

    async function aggiungiStrutturaClasseMacrocategoria(values) {
        const response = await aggiungiStrutturaClasseMacrocategoriaApi(values);
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: () => {
                if (formikRef.current) {
                    formikRef.current.handleSubmit()
                }
            }
        }
    ];

    const initialValuesForm = {
        id_struttura_classe_macrocategoria: '',
        id_classe_macrocategoria: '',
        id_classe_macrocategoria_madre: ''
    };

    return (
        <ModificaStrutturaClasseMacrocategoriaView
            show={show}
            translate={translate}
            aggiungiStrutturaClasseMacrocategoria={aggiungiStrutturaClasseMacrocategoria}
            modalMsg={modalMsg}
            setShow={setShow}
            SignupSchema={SignupSchema}
            formikRef={formikRef}
            optionsClassi={optionsClassi}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
            initialValuesForm={initialValuesForm}
        />
    );
}